import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPurpleCheckmark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 10,
	viewBox: "0 0 12 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path-26",
		d: "M2 5.13509L4.73965 8L10 2",
		stroke: "#AC73FF",
		strokeWidth: 2,
		strokeLinecap: "square"
	})
});
export default SvgPurpleCheckmark;
